<script lang="ts">
  import Pause from '@lucide/svelte/icons/pause';
  import Play from '@lucide/svelte/icons/play';
  import { motionState, toggleMotion } from '$lib/utils/motion-state.svelte';

  let { variant = 'floating' }: { variant?: 'floating' | 'inline' } = $props();
  const label = $derived(motionState.paused ? 'Play motion' : 'Pause motion');
</script>

{#if !motionState.reduced}
  <button
    type="button"
    class="motion-toggle {variant}"
    aria-pressed={motionState.paused}
    aria-label={label}
    onclick={toggleMotion}
    >{#if motionState.paused}<Play size={12} />{:else}<Pause size={12} />{/if}<span class="motion-label">{label}</span
    ></button
  >
{/if}

<style>
  .motion-toggle {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-height: 36px;
    padding: 8px 13px;
    border-radius: 999px;
    font:
      500 11px/1 Geist,
      sans-serif;
    cursor: pointer;
    transition:
      background 200ms,
      color 200ms,
      border-color 200ms,
      transform 300ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  .motion-toggle:active {
    transform: scale(0.96);
  }
  .floating {
    background: #f8fafff0;
    color: #4c6387;
    border: 1px solid #dce3f1;
    box-shadow: 0 10px 24px -16px #142b6160;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
  .floating:hover {
    color: #1447e6;
    border-color: #b9c8ea;
  }
  .inline {
    background: transparent;
    color: inherit;
    border: 1px solid currentColor;
    opacity: 0.85;
  }
  .inline:hover {
    opacity: 1;
  }
</style>
